import { CONFIGURATION_APIS } from "@/api_framework/api_config";
import {
  IConfigurationClinicOnboardPostBody,
  IConfigurationClinicOnboardResponse,
} from "@/api_framework/api_modals/Configuration";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useCurlLogger } from "../../useCurlLogger";
import AxiosCurlirize from "axios-curlirize";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useConfigurationClinicOnboardAPI = () => {
  const [newClinicId, setNewClinicId] = useState<string>("");
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const execute = useCallback(
    async (clinicDataTable: IConfigurationClinicOnboardPostBody) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        if (!clinicDataTable) {
          return;
        }
        await axios
          .post(CONFIGURATION_APIS?.CLINIC_ONBOARD?.baseURL ?? "", clinicDataTable, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IConfigurationClinicOnboardResponse>) => {
            if (res.data.status === true) {
              setNewClinicId(res.data.data.clinic_id);
              toast.success(`${clinicDataTable?.display_name} has been added. `);
            } else {
              toast.error("Error while onboarding clinic.");
            }
          })
          .catch((e: AxiosError) => {
            captureError(e)
            sendCurl(e.config["curlCommand"]);
          });
      } catch (error) {
        if (axios.isAxiosError(error)) {
          const axiosError = error as AxiosError;
          if (axiosError.code === "ERR_BAD_REQUEST") {
            toast.error("Error at server while fetching clinic details.");
          }
          if (axiosError.response?.status === 400) {
            toast.error(axiosError.message);
          }
          if (axiosError.response?.status === 500) {
            toast.error("Internal Server Error, Contact Tech Team.");
          }
        } else {
          toast.error("Server Error: " + error.message);
        }
      }
    },
    [configuration],
  );

  return { newClinicId, execute };
};
